var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-filter-dropdown" },
    [
      _c("div", { staticClass: "dropdown-title" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "b-dropdown",
        {
          attrs: {
            id: "filter-dropdown",
            right: "",
            text:
              _vm.chosenArray.length > 0
                ? _vm.chosenArray.length +
                  " " +
                  _vm.t.jobSearch_V2_Filters_Chosen
                : _vm.t.jobSearch_V2_Choose + " " + _vm.title.toLowerCase(),
            variant: "outline-primary",
          },
          on: {
            show: function ($event) {
              return _vm.changeShowOverlay($event)
            },
            hide: function ($event) {
              return _vm.changeShowOverlay($event)
            },
          },
        },
        [
          _c(
            "b-form-checkbox-group",
            {
              attrs: { stacked: "" },
              model: {
                value: _vm.chosenArray,
                callback: function ($$v) {
                  _vm.chosenArray = $$v
                },
                expression: "chosenArray",
              },
            },
            _vm._l(_vm.filterArray, function (item, index) {
              return item.Name !== null &&
                item.Id !== null &&
                item.Name !== undefined &&
                item.Id !== undefined
                ? _c(
                    "b-form-checkbox",
                    {
                      key: index,
                      attrs: { value: item.Id },
                      on: {
                        change: function ($event) {
                          return _vm.clickedItemFilter(item.Id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.Name))]
                  )
                : _vm._e()
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "dropdown-buttons d-flex justify-content-end mt-2" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn",
                  attrs: {
                    variant:
                      _vm.chosenArray.length > 0
                        ? "primary"
                        : "outline-primary",
                  },
                  on: {
                    click: function ($event) {
                      _vm.chosenArray = []
                      _vm.clickedItemFilter("removeAll")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.t.jobSearch_V2_Reset))]
              ),
              _c(
                "b-button",
                {
                  staticClass: "btn ml-2",
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.startSearch()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.t.general_OK) +
                      " + " +
                      _vm._s(_vm.t.jobSearch_V2_Search)
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }